import Styled from './menuMobile.module.css'
import { Link } from 'react-router-dom'
import * as FI from 'react-icons/fi'
import * as Type from '../../Context/types'
import { LandingContext } from '../../Context'
import { useContext } from 'react'
import * as Scroll from 'react-scroll';

const MenuMobile = ({ updateState }: Type.MenuMobileProps) => {
    const { websiteSettings } = useContext(LandingContext)

    return (
        <div className={Styled.menu_mobile}>
            <button type="button" onClick={() => updateState(false)}>
                <FI.FiX />
            </button>
            <nav>
                <Scroll.Link to="inicio" smooth={true} onClick={() => updateState(false)}>
                    <FI.FiArrowRight />
                    Inicio
                </Scroll.Link>
                <Scroll.Link to="curriculo" smooth={true} onClick={() => updateState(false)}>
                    <FI.FiArrowRight />
                    Curriculo
                </Scroll.Link>
                <Scroll.Link to="servicos" smooth={true} onClick={() => updateState(false)}>
                    <FI.FiArrowRight />
                    Serviços
                </Scroll.Link>
                <Scroll.Link to="depoimentos" smooth={true} onClick={() => updateState(false)}>
                    <FI.FiArrowRight />
                    Depoimentos
                </Scroll.Link>
                <a target="_black" href={websiteSettings.blog}>
                    <FI.FiArrowRight />
                    Blog
                </a>
                <Scroll.Link to="contato" smooth={true} onClick={() => updateState(false)}>
                    <FI.FiArrowRight />
                    Contato
                </Scroll.Link>
                <Link to="/private/login">
                    Entrar
                    <FI.FiLogIn />
                </Link>
            </nav>
        </div>
    )
}

export default MenuMobile